import { render, staticRenderFns } from "./GroceryPageTemplateModule.vue?vue&type=template&id=45814bb2&"
import script from "./GroceryPageTemplateModule.vue?vue&type=script&lang=js&"
export * from "./GroceryPageTemplateModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports